<template>
    <div>
        <h1>{{this.$route.params.id}} Històric de lectures</h1>
        <b-container fluid>
            <b-row>
                <b-col align-self="start" class="text-left">
                    <b-form-select
                            style="width: 100px; margin-bottom: 17px; margin-right: 5px;"
                            id="cmb-per-page"
                            v-model="perPage"
                            required
                    >
                        <!--:options=this.perPageValues-->
                        <option>15</option>
                        <option>30</option>
                        <option>50</option>
                        <option>100</option>
                        <option>200</option>
                    </b-form-select>
                    <b-button size="sm" @click="currentPage=1" class="mr-2" style="margin-bottom: 20px;"
                              :disabled="isFirstPage">
                        <span><font-awesome-icon icon="angle-double-left"/>&nbsp;</span>
                    </b-button>
                    <b-button size="sm" @click="currentPage--" class="mr-2" style="margin-bottom: 20px;"
                              :disabled="isFirstPage">
                        <span><font-awesome-icon icon="angle-left"/>&nbsp;</span>
                    </b-button>
                    <b-button size="sm" @click="currentPage++" class="mr-2" style="margin-bottom: 20px;"
                              :disabled="isLastPage">
                        <span><font-awesome-icon icon="angle-right"/>&nbsp;</span>
                    </b-button>
                    <b-button size="sm" @click="currentPage=lastPage" class="mr-2" style="margin-bottom: 20px;"
                              :disabled="isLastPage">
                        <span><font-awesome-icon icon="angle-double-right"/>&nbsp;</span>
                    </b-button>
                    <span style="margin-bottom: 20px;">Página {{this.currentPage}}</span>
                </b-col>
                <b-col>
                    <b-button size="sm" @click="$router.go(-1)" class="mr-2" style="margin-bottom: 20px;">
                        <span><font-awesome-icon icon="backward"/>&nbsp;&nbsp;Tornar enrere</span>
                    </b-button>
                </b-col>
                <b-col>
                    <b-button v-b-modal.modal-download>Descarregar Lectures (Excel)</b-button>
                </b-col>
            </b-row>
        </b-container>

        <b-table
                striped
                hover
                small
                responsive
                stacked="sm"
                :busy="this.$store.state.loadingPanels"
                v-bind:fields="fields"
                v-bind:items="rows"
        >
            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"/>
                <strong>&nbsp; Carregant dades...</strong>
            </div>

            <template slot="showDetails" slot-scope="row">
                <b-button size="sm" @click="row.toggleDetails" class="mr-2">
                    <span><font-awesome-icon icon="info"/></span>
                </b-button>
            </template>

            <template slot="row-details" slot-scope="row">
                <b-card>
                    <table class="table table-borderless">
                        <tbody>
                        <tr v-if="row.item.reading.power_status_code === 'error'">
                            <td class="danger-cell">Error</td>
                            <td class="base-cell">Potència</td>
                            <td class="base-cell message-cell">{{ row.item.reading.power_status_message }}</td>
                        </tr>
                        <tr v-if="row.item.reading.position_status_code === 'error'">
                            <td class="danger-cell">Error</td>
                            <td class="base-cell">Posició</td>
                            <td class="base-cell message-cell">{{ row.item.reading.position_status_message }}</td>
                        </tr>
                        <tr v-if="row.item.reading.power_status_code === 'warning'">
                            <td class="warning-cell">Alerta</td>
                            <td class="base-cell">Potència</td>
                            <td class="base-cell message-cell">{{ row.item.reading.power_status_message }}</td>
                        </tr>
                        <tr v-if="row.item.reading.position_status_code === 'warning'">
                            <td class="warning-cell">Alerta</td>
                            <td class="base-cell">Posició</td>
                            <td class="base-cell message-cell">{{ row.item.reading.position_status_message }}</td>
                        </tr>
                        </tbody>
                        <tr v-for="validation in row.item.reading.power_failed_validations">
                            <td v-if="validation.type === 'alarm'" class="danger-cell">Alarma</td>
                            <td v-if="validation.type === 'alert'" class="warning-cell">Alerta</td>
                            <td v-if="validation.type === 'info'" class="validation-cell">Info</td>
                            <td class="base-cell">Potència</td>
                            <td class="base-cell message-cell">{{ validation.message }}</td>
                        </tr>
                        <tr v-for="validation in row.item.reading.position_failed_validations">
                            <td v-if="validation.type === 'alarm'" class="danger-cell">Alarma</td>
                            <td v-if="validation.type === 'alert'" class="warning-cell">Alerta</td>
                            <td v-if="validation.type === 'info'" class="validation-cell">Info</td>
                            <td class="base-cell">Posició</td>
                            <td class="base-cell message-cell">{{ validation.message }}</td>
                        </tr>
                        <tr v-if="row.item.reading.power_p1_status_value.length > 0">
                            <td class="validation-cell">Info</td>
                            <td class="base-cell">Estat P1</td>
                            <td class="base-cell message-cell">{{ row.item.reading.power_p1_status_value }}</td>
                        </tr>
                        <tr v-if="row.item.reading.power_p2_status_value.length > 0">
                            <td class="validation-cell">Info</td>
                            <td class="base-cell">Estat P2</td>
                            <td class="base-cell message-cell">{{ row.item.reading.power_p2_status_value }}</td>
                        </tr>
                        <tr v-if="row.item.reading.power_p3_status_value.length > 0">
                            <td class="validation-cell">Info</td>
                            <td class="base-cell">Estat P3</td>
                            <td class="base-cell message-cell">{{ row.item.reading.power_p3_status_value }}</td>
                        </tr>
                        <tr v-if="row.item.reading.position_zenital_status_value.length > 0">
                            <td class="validation-cell">Info</td>
                            <td class="base-cell">Estat Zenit(Y)</td>
                            <td class="base-cell message-cell">{{ row.item.reading.position_zenital_status_value }}</td>
                        </tr>
                        <tr v-if="row.item.reading.position_azimuthal_status_value.length > 0">
                            <td class="validation-cell">Info</td>
                            <td class="base-cell">Estat Azimut(X)</td>
                            <td class="base-cell message-cell">{{ row.item.reading.position_azimuthal_status_value }}
                            </td>
                        </tr>
                    </table>
                    <b-button :id="'show-asp-guide-' + row.item.id" v-on:click="$bvToast.show('asp-status-guide-' + row.item.id)" v-show="row.item.powerMeasurer === 'EppcPowerASP'">Guia d'estats EPPC ASP</b-button>
                    <b-toast :id="'asp-status-guide-' + row.item.id" title="Guia d'estats per EPPC ASP" no-auto-hide solid variant="info" toaster="b-toaster-bottom-full">
                        <ul>
                            <li>Per un valor d'estat, p.ex.: 00000103.</li>
                            <li>Els primer 4 digits (0000) són etiquetes de control intern, sense rellevància.</li>
                            <li>Els digits 5 i 6 (01) indiquen l'estat intern de l'ondulador. Sense rellevància.</li>
                            <li>Els dos últims digits 7 i 8 (03) expressen diferents situacions:
                                <ul>
                                    <li>00: No s'obté resposta.</li>
                                    <li>02: ASP-CAN Ok. No hi ha dades.</li>
                                    <li>03: Dades Ok.</li>
                                </ul>
                            </li>
                        </ul>
                    </b-toast>

                    <b-button :id="'show-xantrex-guide-' + row.item.id" v-on:click="$bvToast.show('xantrex-status-guide-' + row.item.id)" v-show="row.item.powerMeasurer === 'EppcPowerXantrex'">Guia d'estats EPPC Xantrex</b-button>
                    <b-toast :id="'xantrex-status-guide-' + row.item.id" title="Guia d'estats per EPPC Xantrex" no-auto-hide solid variant="info" toaster="b-toaster-bottom-full">
                        <ul>
                            <li>Per un valor d'estat, p.ex.: 00040001.</li>
                            <li>Els primer 2 digits (00) són etiquetes de control intern, sense rellevància.</li>
                            <li>Els 4 digits, del 3 fins al 6 inclosos, indiquen:
                                <ul>
                                    <li>0400: Invert</li>
                                    <li>0401: AC Passthru</li>
                                    <li>0402: APS Only</li>
                                    <li>0403: Load Sense</li>
                                    <li>0404: Inverter Disabled</li>
                                    <li>0405: Load Sense Ready</li>
                                    <li>0406: Engaging Inverter</li>
                                    <li>0407: Invert Fault</li>
                                    <li>0408: Inverter Standby</li>
                                    <li>0409: Grid-Tied</li>
                                </ul>
                            </li>
                            <li>Els dos últims digits 7 i 8 (01) indiquen:
                                <ul>
                                    <li>00: No hi ha ondulador</li>
                                    <li>01: Dades Ok</li>
                                </ul>
                            </li>
                        </ul>
                    </b-toast>

                    <b-button :id="'show-modicon-guide-' + row.item.id" v-on:click="$bvToast.show('modicon-status-guide-' + row.item.id)" v-show="row.item.positionMeasurer === 'Modicon'">Guia d'estats Modicon</b-button>
                    <b-toast :id="'modicon-status-guide-' + row.item.id" title="Guia d'estats per MODICON" no-auto-hide solid variant="info" toaster="b-toaster-bottom-full">
                        <ul>
                            <li>bit 0: '0' ok; '1' Alarma de posició detectada per la pantalla (no és possible situar-se en la posició teòrica)</li>
                            <li>bit 1: '0' ok; '1' Alarma de vent. Ho informa la pantalla.</li>
                            <li>bit 2: '0' ok; '1' Alarma de comunicació entre PLC màster i PLC slave(pantalla). Ho informa la pantalla.</li>
                            <li>bit 3: '0' ok; '1' Alarma de vent, ho informa el màster. Quan es produeixi una alarma de vent, qui té la informació és el màster i
                                la passa a slave (PLC pantalla) per tant tant el bit 1 com el 3 s’haurien d’activar.</li>
                            <li>bit 4: '0' ok; '1' alarma de comunicació, detectada pel màster.  Quan es produeix una alarma de comunicació entre el màster i un slave (pantalla),
                                el més normal és que sigui el màster el que detecti aquest error i no tinguem informació de l’slave (ja que no hi tenim comunicació),
                                però s’ha posar també l’alarma de comunicació de slave per si ens pot aportar més informació.</li>
                            <li>bit 5: '0' mode manual; '1' mode de la planta en automàtic.</li>
                        </ul>
                    </b-toast>
                </b-card>
            </template>
        </b-table>

        <div>
            <b-modal id="modal-download" title="Descarregar lectures del seguidor"
                     ok-title="Descarregar"
                     cancel-title="Tancar"
                     :ok-disabled="downloading"
                     :cancel-disabled="downloading"
                     hide-header-close
                     v-on:ok="downloadReadings">

                <p class="my-4">Introdueix les dates d'inici i final del període i prem al botó de
                    <strong>Descarregar</strong>
                </p>
                Inici:
                <b-form-input type="date" v-model="downloadDateStart"></b-form-input>
                Final:
                <b-form-input type="date" v-model="downloadDateEnd"></b-form-input>
                <br/>
                <b-alert variant="danger" :show="incorrectRange">El rang de dates és incorrecte.</b-alert>
                <b-spinner v-show="downloading"></b-spinner>
            </b-modal>
        </div>
    </div>
</template>

<style scoped>
    .danger-cell {
        background-color: #f5c6cb;
    }

    .warning-cell {
        background-color: #ffeeba;
    }

    .validation-cell {
        background-color: #bee5eb;
    }

    .message-cell {
        text-align: left;
    }

    .base-cell {
        background-color: white;
    }
</style>

<script>
    //import PanelsTable from "../components/PanelsTable"
    import Api from "../api"
    import router from '../router'

    export default {
        name: "PanelReadingsView",
        data: function () {
            return {
                readings: [],
                perPage: 15,
                currentPage: 1,
                lastPage: 1,
                isFirstPage: true,
                isLastPage: true,
                downloadDateStart: null,
                downloadDateEnd: null,
                incorrectRange: false,
                downloading: false,
            }
        },
        watch: {
            perPage: function () {
                this.loadReadings()
            },
            currentPage: function () {
                this.loadReadings()
            }
        },
        methods: {
            loadReadings() {
                this.readings = []
                this.$store.commit('setLoadingPanels', true)
                Api.readings(this.$route.params.id, this.perPage, this.currentPage).then(response => {
                    //window.console.log(response)
                    this.readings = response.data.data
                    this.currentPage = response.data.meta.current_page
                    this.lastPage = response.data.meta.last_page
                    this.isLastPage = (this.currentPage === this.lastPage)
                    this.isFirstPage = (this.currentPage === 1)
                }).catch(error => {
                    if (error.response && error.response.status === 401) {
                        //Unauthorized:
                        router.push('/login')
                    }
                }).finally(() => {
                    this.$store.commit('setLoadingPanels', false)
                })
            },
            downloadReadings(bvModalEvt) {
                bvModalEvt.preventDefault()

                this.incorrectRange = (!this.downloadDateStart || !this.downloadDateEnd)
                this.incorrectRange = this.incorrectRange || (this.downloadDateEnd < this.downloadDateStart)
                if (this.incorrectRange) {
                    return
                }

                this.downloading = true

                Api.readingsDownload(this.$route.params.id, this.downloadDateStart, this.downloadDateEnd)
                    .then(({data}) => {
                        let blob = new Blob([data], {type: data.type})
                        let link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = 'LecturesSeguidor.xlsx'
                        link.click()
                        this.downloading = false
                    })
                    .catch(({error}) => {
                        window.console.log(error)
                        this.downloading = false
                    })

            }
        },
        mounted() {
            this.loadReadings()
        },
        computed: {
            fields() {
                return {
                    power1: {
                        label: 'Potència (P1)',
                        sortable: true
                    },
                    power2: {
                        label: 'Potència (P2)',
                        sortable: true
                    },
                    power3: {
                        label: 'Potència (P3)',
                        sortable: true
                    },
                    /*powerMessage: {
                        label: 'Missatge',
                        sortable: true,
                    },*/
                    zenit: {
                        label: 'Zenit(Y)',
                        sortable: true
                    },
                    azimuth: {
                        label: 'Azimut(X)',
                        sortable: true
                    },
                    /*positionMessage: {
                        label: 'Missatge',
                        sortable: true,
                    },*/
                    registeredAt: {
                        label: 'Última lectura',
                        sortable: true
                    },
                    showDetails: {
                        label: 'Detalls'
                    }
                }
            },
            rows() {
                //Apply styling for warnigs and other possible item related information to display on table:
                let rows = []
                this.readings.forEach(reading => {
                    let row = {
                        id: reading.id,
                        powerMeasurer: reading.power_measurer_type,
                        power1: reading.power_p1,
                        power2: reading.power_p2,
                        power3: reading.power_p3,
                        powerMessage: reading.power_status_message,
                        positionMeasurer: reading.position_measurer_type,
                        zenit: reading.position_zenital_angle,
                        azimuth: reading.position_azimuthal_angle,
                        positionMessage: reading.position_status_message,
                        registeredAt: reading.registered_at,
                        reading: reading,
                        _cellVariants: {}
                    }

                    let powerVariantDefined = false
                    if (row.reading.power_status_code === 'warning') {
                        row._cellVariants.power1 = 'warning'
                        row._cellVariants.power2 = 'warning'
                        row._cellVariants.power3 = 'warning'
                        powerVariantDefined = true
                    }
                    if (row.reading.power_status_code === 'error') {
                        row._cellVariants.power1 = 'danger'
                        row._cellVariants.power2 = 'danger'
                        row._cellVariants.power3 = 'danger'
                        powerVariantDefined = true
                    }

                    let positionVariantDefined = false
                    if (row.reading.position_status_code === 'warning') {
                        row._cellVariants.zenit = 'warning'
                        row._cellVariants.azimuth = 'warning'
                        positionVariantDefined = true
                    }
                    if (row.reading.position_status_code === 'error') {
                        row._cellVariants.zenit = 'danger'
                        row._cellVariants.azimuth = 'danger'
                        positionVariantDefined = true
                    }

                    if (row.reading.power_failed_validations.length > 0 && !powerVariantDefined) {
                        let alerts = 0
                        let alarms = 0
                        row.reading.power_failed_validations.forEach(function (validation) {
                            if (validation.type === 'alarm') {
                                alarms++
                            }
                            if (validation.type === 'alert') {
                                alerts++
                            }
                        })
                        if (alarms > 0) {
                            row._cellVariants.power1 = 'danger'
                            row._cellVariants.power2 = 'danger'
                            row._cellVariants.power3 = 'danger'
                        } else if (alerts > 0) {
                            row._cellVariants.power1 = 'warning'
                            row._cellVariants.power2 = 'warning'
                            row._cellVariants.power3 = 'warning'
                        } else {
                            row._cellVariants.power1 = 'info'
                            row._cellVariants.power2 = 'info'
                            row._cellVariants.power3 = 'info'
                        }
                    }
                    if (row.reading.position_failed_validations.length > 0 && !positionVariantDefined) {
                        let alerts = 0
                        let alarms = 0
                        row.reading.position_failed_validations.forEach(function (validation) {
                            if (validation.type === 'alarm') {
                                alarms++
                            }
                            if (validation.type === 'alert') {
                                alerts++
                            }
                        })
                        if (alarms > 0) {
                            row._cellVariants.zenit = 'danger'
                            row._cellVariants.azimuth = 'danger'
                        } else if (alerts > 0) {
                            row._cellVariants.zenit = 'warning'
                            row._cellVariants.azimuth = 'warning'
                        } else {
                            row._cellVariants.zenit = 'info'
                            row._cellVariants.azimuth = 'info'
                        }
                    }

                    rows.push(row)
                })
                return rows
            }
        }
    }

</script>

<style scoped>

</style>